import { render, staticRenderFns } from "./GoogleAnalitycs.vue?vue&type=template&id=7b56eea2&scoped=true"
import script from "./GoogleAnalitycs.vue?vue&type=script&lang=js"
export * from "./GoogleAnalitycs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b56eea2",
  null
  
)

export default component.exports